module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded1"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("To Kim—"), _c('br'), _vm._v("We look forward to sharing"), _c('br'), _vm._v("with you the table He has"), _c('br'), _vm._v("prepared for us."), _c('br'), _vm._v("Psalm 23: 1–6"), _c('br'), _vm._v("With love,"), _c('br'), _vm._v("Blake, Brooke, and Roxie")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_ded2.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("To my dad, Tom Reeves—"), _c('br'), _vm._v("For teaching me to find art in words."), _c('br'), _vm._v("Love, Shelly")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_ded3.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bb0f94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400217_epub_ded1_r1.vue
// module id = 72
// module chunks = 0